import {createSelector} from 'reselect';
import {getSelectedPudoAddress, hasSavedPudoAddresses} from './PudoSelectors';
import {getSettings, isGuest} from './selectors';

export default createSelector(
  [isGuest, hasSavedPudoAddresses, getSelectedPudoAddress, getSettings],
  (guest, pudoSavedAddresses, selectedPudoAddress, settings) => (guest && pudoSavedAddresses)
    || (!!selectedPudoAddress?.newCollectionPoint && !!settings?.change_new_pudo_collection_point),
);
